export default {
      id: "dpo-admin-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#dpo-admin",
      toString: function () {
        return this.url;
      }
    }